<template>
    <div id="sign-in">
        <!-- mb-3 -->
        <div class="sign-in__card">
            <!-- header menu(login with gmail/shopify or facebook) -->
            <div class="sign-in__card--header">
                <h1 class="sign-in__card--header-title mb-2">{{$t('login.welcome')}}</h1>
                <p class="sign-in__card--header-para mb-4" v-if="!isScalifyLogin && !isShopifyLogin">{{$t('login.sign_in_to_your_account')}}</p>
                <p class="sign-in__card--header-para mb-0" v-if="isScalifyLogin && !isShopifyLogin">{{$t('login.sign_in_using_email_passowrd')}}</p>
                <p class="sign-in__card--header-para mb-0" v-if="isShopifyLogin">{{$t('login.sign_in_with_shopify')}}</p>
                <div v-show="!isScalifyLogin && !isShopifyLogin && !isBigCommerceLogin">

                    <!-- login with facebook -->
                    <div class="row no-gutters mb-2" style="height:48px;">
                        <button class="btn btn--white sign-in__with__button btn--lg" @click.stop="loginUsingFb">
                            <div class="left-part">
                                <svg class="fb-icon" width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.12886 5.84224C8.07051 6.41985 8.01437 6.97153 7.95822 7.52391C7.92726 7.82783 7.88618 8.13106 7.8696 8.43498C7.85735 8.6575 7.77595 8.7526 7.53973 8.7475C6.95494 8.73457 6.37016 8.74179 5.78536 8.74393C5.38421 8.74537 5.37485 8.75686 5.37485 9.15009C5.37844 11.8587 5.38205 14.5674 5.38565 17.2754C5.38637 17.6434 5.38493 17.6441 5.01619 17.6441C4.06265 17.6448 3.10838 17.6362 2.15485 17.6499C1.90061 17.6535 1.83796 17.5677 1.83868 17.3251C1.84588 14.6164 1.84372 11.9077 1.843 9.19908C1.843 8.76911 1.84228 8.76911 1.40944 8.76842C1.03134 8.76766 0.653236 8.7612 0.275854 8.77055C0.084281 8.77558 -0.00142255 8.71585 1.78456e-05 8.5106C0.00721978 7.69173 0.00649961 6.87285 0.000738045 6.05398C-0.000702354 5.87681 0.0669961 5.8156 0.238403 5.81848C0.643154 5.82568 1.0479 5.82064 1.45338 5.82136C1.81779 5.82208 1.84156 5.80263 1.84228 5.44686C1.84444 4.80804 1.82932 4.16851 1.84732 3.53042C1.86605 2.87 1.98056 2.22326 2.29169 1.63126C2.76917 0.721648 3.56932 0.221113 4.55022 0.121005C5.67373 0.00649407 6.81092 0.0252192 7.94232 1.23102e-05C8.00287 -0.00142808 8.1195 0.123886 8.12026 0.190864C8.13251 1.03638 8.12673 1.88261 8.13031 2.72812C8.13106 2.89448 8.05613 2.94345 7.89911 2.94418C7.38636 2.94634 6.87213 2.93337 6.36223 2.97299C5.63556 3.02988 5.38853 3.3266 5.38565 4.05472C5.38421 4.52285 5.37701 4.99026 5.37628 5.45838C5.37557 5.812 5.39285 5.82784 5.73782 5.82784C6.43066 5.82857 7.12345 5.82712 7.81634 5.82857C7.91281 5.82928 8.00934 5.83721 8.12886 5.84224Z" fill="#2A8CFF"/>
                                </svg>
                            </div>
                            <div class="right-part text-center" :style="loadingSignIn == 'facebook'?{width:'calc(100% - 45px)',left: '45px'}:{}">
                                <s-loader type="scalify" v-if="loadingSignIn=='facebook'"></s-loader>
                                <p v-else>{{$t('login.sign_in_with_facebook')}}</p>
                            </div>
                        </button>
                    </div>

                    <!-- login with google -->
                    <div class="row no-gutters mb-2" style="height:48px;">
                        <button ref="googlebtn" class="g-signin2" id="my-signin2" hidden></button>
                        <button class="btn btn--white sign-in__with__button btn--lg" @click.stop="signinGoogle">
                            <div class="left-part">
                                <svg class="shopify-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0)">
                                    <path d="M19.1565 10.1871C19.1565 9.3677 19.0913 8.76976 18.9502 8.14969H9.77423V11.848H15.1603C15.0518 12.7671 14.4654 14.1512 13.1623 15.0813L13.144 15.2051L16.0453 17.4969L16.2463 17.5174C18.0923 15.7789 19.1565 13.2211 19.1565 10.1871Z" fill="#4285F4"/>
                                    <path d="M9.77426 19.9313C12.413 19.9313 14.6282 19.0454 16.2463 17.5174L13.1623 15.0813C12.337 15.6682 11.2294 16.0779 9.77426 16.0779C7.18979 16.0779 4.99625 14.3395 4.21432 11.9366L4.0997 11.9466L1.08291 14.3273L1.04346 14.4391C2.6506 17.6945 5.9518 19.9313 9.77426 19.9313Z" fill="#34A853"/>
                                    <path d="M4.2143 11.9366C4.00798 11.3166 3.88858 10.6521 3.88858 9.96565C3.88858 9.27908 4.00798 8.61473 4.20345 7.99466L4.19798 7.8626L1.14339 5.44366L1.04345 5.49214C0.381067 6.84305 0.000991821 8.36008 0.000991821 9.96565C0.000991821 11.5712 0.381067 13.0882 1.04345 14.4391L4.2143 11.9366Z" fill="#FBBC05"/>
                                    <path d="M9.77425 3.85336C11.6094 3.85336 12.8473 4.66168 13.5532 5.33718L16.3114 2.59107C14.6174 0.985496 12.413 0 9.77425 0C5.95179 0 2.6506 2.23672 1.04346 5.49214L4.20346 7.99466C4.99625 5.59183 7.18978 3.85336 9.77425 3.85336Z" fill="#EB4335"/>
                                    </g>
                                    <defs>
                                    <clipPath id="clip0">
                                    <rect width="19.1667" height="20" fill="white"/>
                                    </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <div class="right-part text-center" :style="loadingSignIn == 'google'?{width:'calc(100% - 45px)',left: '45px'}:{}">
                                <s-loader type="scalify" v-if="loadingSignIn=='google'"></s-loader>
                                <p v-else>{{$t('login.sign_in_with_google')}}</p>
                            </div>
                        </button>
                    </div>

                    <!-- login with shopify -->
                    <div v-if="false" class="row no-gutters" style="height:48px;">
                        <button class="btn btn--white sign-in__with__button btn--lg" @click.stop="isShopifyLogin = !isShopifyLogin">
                            <div class="left-part">
                                <svg class="shopify-icon" width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.4637 3.84516C15.4493 3.74438 15.3629 3.68678 15.2909 3.68678C15.2189 3.68678 13.7935 3.65799 13.7935 3.65799C13.7935 3.65799 12.5985 2.50613 12.4833 2.37654C12.3681 2.26136 12.1377 2.29015 12.0513 2.31895C12.0513 2.31895 11.821 2.39094 11.4466 2.50613C11.389 2.30455 11.2882 2.05978 11.1586 1.80061C10.7411 0.994311 10.1076 0.562363 9.35886 0.562363C9.30127 0.562363 9.25807 0.562363 9.20048 0.576761C9.17168 0.547965 9.15729 0.519168 9.12849 0.50477C8.79733 0.159212 8.37978 -0.0135668 7.87584 0.000831489C6.91116 0.029628 5.94648 0.735142 5.15457 1.97339C4.60744 2.85169 4.18989 3.94595 4.06031 4.79545C2.95164 5.14101 2.17414 5.38578 2.14534 5.38578C1.58381 5.55856 1.56941 5.57295 1.49742 6.10569C1.46862 6.50884 0 17.8691 0 17.8691L12.3249 20L17.6667 18.6754C17.6523 18.6754 15.4781 3.94595 15.4637 3.84516ZM10.8275 2.7077C10.5395 2.79409 10.2228 2.89488 9.8772 3.01007C9.8772 2.52053 9.80521 1.82941 9.58923 1.25348C10.3235 1.36867 10.6835 2.20376 10.8275 2.7077ZM9.22928 3.19724C8.58136 3.39882 7.87584 3.61479 7.17033 3.83077C7.3719 3.06766 7.74626 2.31895 8.207 1.81501C8.37978 1.62783 8.62455 1.42626 8.89812 1.31107C9.18608 1.8726 9.24368 2.66451 9.22928 3.19724ZM7.90464 0.648753C8.13501 0.648753 8.32219 0.691947 8.48057 0.807133C8.2214 0.936718 7.96223 1.13829 7.73186 1.39746C7.11273 2.05978 6.63759 3.08206 6.45042 4.07554C5.86009 4.26271 5.28416 4.43549 4.76582 4.59387C5.11138 3.02446 6.42162 0.691948 7.90464 0.648753Z" fill="#95BF47"/>
                                    <path d="M15.291 3.6868C15.219 3.6868 13.7935 3.658 13.7935 3.658C13.7935 3.658 12.5985 2.50614 12.4833 2.37656C12.4401 2.33336 12.3825 2.30457 12.3249 2.30457V20L17.6667 18.6754C17.6667 18.6754 15.4925 3.94597 15.4781 3.84518C15.4493 3.74439 15.3629 3.6868 15.291 3.6868Z" fill="#5E8E3E"/>
                                    <path d="M9.35887 6.43685L8.73974 8.75497C8.73974 8.75497 8.04863 8.43821 7.22793 8.4958C6.01847 8.56779 6.01847 9.3309 6.01847 9.51808C6.09046 10.5548 8.81173 10.7851 8.97011 13.2184C9.0853 15.1334 7.96224 16.4436 6.32084 16.5444C4.36268 16.6452 3.28281 15.4934 3.28281 15.4934L3.70036 13.7224C3.70036 13.7224 4.79462 14.5431 5.65852 14.4855C6.22005 14.4567 6.43602 13.9815 6.40723 13.6648C6.32084 12.3113 4.10351 12.3977 3.95952 10.166C3.84434 8.29423 5.06819 6.40805 7.77506 6.23528C8.82613 6.16328 9.35887 6.43685 9.35887 6.43685Z" fill="white"/>
                                </svg>
                            </div>
                            <div class="right-part text-center" :style="loadingSignIn == 'shopify'?{width:'calc(100% - 45px)',left: '45px'}:{}">
                                <s-loader type="scalify" v-if="loadingSignIn=='shopify'"></s-loader>
                                <p v-else>{{$t('login.btn_sign_in_with_shopify')}}</p>
                            </div>
                        </button>
                    </div>

                    <!-- login with bigcommerce -->
                    <div v-if="false" class="row no-gutters" style="height:48px;">
                        <button class="btn btn--white sign-in__with__button btn--lg" @click.stop="isBigCommerceLogin = !isBigCommerceLogin">
                            <div class="left-part">
                                <!-- <svg class="shopify-icon" width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.4637 3.84516C15.4493 3.74438 15.3629 3.68678 15.2909 3.68678C15.2189 3.68678 13.7935 3.65799 13.7935 3.65799C13.7935 3.65799 12.5985 2.50613 12.4833 2.37654C12.3681 2.26136 12.1377 2.29015 12.0513 2.31895C12.0513 2.31895 11.821 2.39094 11.4466 2.50613C11.389 2.30455 11.2882 2.05978 11.1586 1.80061C10.7411 0.994311 10.1076 0.562363 9.35886 0.562363C9.30127 0.562363 9.25807 0.562363 9.20048 0.576761C9.17168 0.547965 9.15729 0.519168 9.12849 0.50477C8.79733 0.159212 8.37978 -0.0135668 7.87584 0.000831489C6.91116 0.029628 5.94648 0.735142 5.15457 1.97339C4.60744 2.85169 4.18989 3.94595 4.06031 4.79545C2.95164 5.14101 2.17414 5.38578 2.14534 5.38578C1.58381 5.55856 1.56941 5.57295 1.49742 6.10569C1.46862 6.50884 0 17.8691 0 17.8691L12.3249 20L17.6667 18.6754C17.6523 18.6754 15.4781 3.94595 15.4637 3.84516ZM10.8275 2.7077C10.5395 2.79409 10.2228 2.89488 9.8772 3.01007C9.8772 2.52053 9.80521 1.82941 9.58923 1.25348C10.3235 1.36867 10.6835 2.20376 10.8275 2.7077ZM9.22928 3.19724C8.58136 3.39882 7.87584 3.61479 7.17033 3.83077C7.3719 3.06766 7.74626 2.31895 8.207 1.81501C8.37978 1.62783 8.62455 1.42626 8.89812 1.31107C9.18608 1.8726 9.24368 2.66451 9.22928 3.19724ZM7.90464 0.648753C8.13501 0.648753 8.32219 0.691947 8.48057 0.807133C8.2214 0.936718 7.96223 1.13829 7.73186 1.39746C7.11273 2.05978 6.63759 3.08206 6.45042 4.07554C5.86009 4.26271 5.28416 4.43549 4.76582 4.59387C5.11138 3.02446 6.42162 0.691948 7.90464 0.648753Z" fill="#95BF47"/>
                                    <path d="M15.291 3.6868C15.219 3.6868 13.7935 3.658 13.7935 3.658C13.7935 3.658 12.5985 2.50614 12.4833 2.37656C12.4401 2.33336 12.3825 2.30457 12.3249 2.30457V20L17.6667 18.6754C17.6667 18.6754 15.4925 3.94597 15.4781 3.84518C15.4493 3.74439 15.3629 3.6868 15.291 3.6868Z" fill="#5E8E3E"/>
                                    <path d="M9.35887 6.43685L8.73974 8.75497C8.73974 8.75497 8.04863 8.43821 7.22793 8.4958C6.01847 8.56779 6.01847 9.3309 6.01847 9.51808C6.09046 10.5548 8.81173 10.7851 8.97011 13.2184C9.0853 15.1334 7.96224 16.4436 6.32084 16.5444C4.36268 16.6452 3.28281 15.4934 3.28281 15.4934L3.70036 13.7224C3.70036 13.7224 4.79462 14.5431 5.65852 14.4855C6.22005 14.4567 6.43602 13.9815 6.40723 13.6648C6.32084 12.3113 4.10351 12.3977 3.95952 10.166C3.84434 8.29423 5.06819 6.40805 7.77506 6.23528C8.82613 6.16328 9.35887 6.43685 9.35887 6.43685Z" fill="white"/>
                                </svg> -->
                                <img src="./../../../assets/images/bigcommerce.svg" class="shopify-icon" width="18" height="20" />
                            </div>
                            <div class="right-part text-center">
                                <s-loader v-if="loadingSignIn=='bigcommerce'"></s-loader>
                                <p v-else>{{$t('login.sign_in_with_big_commerce')}}</p>
                            </div>
                        </button>
                    </div>

                </div>
            </div>

            <!-- login with email form -->
            <form id="scalify-form" v-if="!isShopifyLogin && !isBigCommerceLogin" @submit.prevent="loginScalify" class="sign-in__card--body">
                <p class="m-0 display-block sign-in__card--body__title mb-3" v-if="!isScalifyLogin">{{$t('login.use_email_adress')}}</p>
                <s-input :id="'scalify-email'" name="email" v-model="email" class="mb-3 sign-in__card--body__input" fieldFor="settings" :placeholder="$t('login.placeholder_email')"></s-input>
                <div class="sign-in__card--body__password mb-3" v-if="isScalifyLogin">
                    <s-input name="password" class="sign-in__card--body__input password" v-model="password" :type="typeInputPass" fieldFor="settings" :placeholder="$t('login.placeholder_password')"></s-input>
                    <svg class="sign-in__card--body__password--eye" @click.stop="changeInputPassType" v-if="typeInputPass=='password'" width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 2.77778C9.63199 2.78354 9.2667 2.842 8.91528 2.95139C9.07783 3.23727 9.16438 3.56004 9.16667 3.8889C9.16667 4.14424 9.11637 4.39709 9.01865 4.633C8.92093 4.86892 8.77771 5.08327 8.59715 5.26383C8.41659 5.44439 8.20224 5.58761 7.96632 5.68533C7.73041 5.78305 7.47757 5.83334 7.22222 5.83334C6.89336 5.83106 6.57059 5.74451 6.28471 5.58195C6.05917 6.36418 6.08546 7.19754 6.35985 7.96399C6.63425 8.73044 7.14284 9.39113 7.8136 9.85247C8.48435 10.3138 9.28325 10.5524 10.0971 10.5345C10.911 10.5165 11.6987 10.243 12.3484 9.75256C12.9982 9.26212 13.4772 8.57968 13.7176 7.80188C13.958 7.02409 13.9475 6.19038 13.6877 5.41885C13.428 4.64732 12.932 3.97709 12.2702 3.50308C11.6083 3.02907 10.8141 2.77533 10 2.77778ZM19.8792 6.15973C17.9962 2.48577 14.2684 0 10 0C5.73159 0 2.00276 2.4875 0.120815 6.16008C0.0413845 6.3172 0 6.4908 0 6.66685C0 6.84291 0.0413845 7.0165 0.120815 7.17362C2.0038 10.8476 5.73159 13.3334 10 13.3334C14.2684 13.3334 17.9972 10.8459 19.8792 7.17328C19.9586 7.01616 20 6.84256 20 6.66651C20 6.49045 19.9586 6.31685 19.8792 6.15973ZM10 11.6667C6.57465 11.6667 3.43436 9.75696 1.73853 6.66668C3.43436 3.5764 6.5743 1.66667 10 1.66667C13.4257 1.66667 16.5656 3.5764 18.2615 6.66668C16.566 9.75696 13.4257 11.6667 10 11.6667Z" fill="#2B4D75"/>
                    </svg>
                    <svg class="sign-in__card--body__password--eye big" @click.stop="changeInputPassType" v-else width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.8122 14.7183L1.12527 0.109684C1.07402 0.0686475 1.01518 0.0381079 0.952123 0.0198092C0.889065 0.00151057 0.823021 -0.00418879 0.75776 0.00303655C0.6925 0.0102619 0.629302 0.0302704 0.571775 0.0619198C0.514247 0.0935691 0.463517 0.136239 0.42248 0.187494L0.10999 0.577795C0.0688564 0.629068 0.0382372 0.687948 0.0198841 0.751067C0.00153093 0.814185 -0.00419592 0.880304 0.0030312 0.945638C0.0102583 1.01097 0.0302976 1.07424 0.0620023 1.13182C0.093707 1.1894 0.136455 1.24017 0.1878 1.28121L18.8747 15.8898C18.926 15.9309 18.9848 15.9614 19.0479 15.9797C19.1109 15.998 19.177 16.0037 19.2422 15.9965C19.3075 15.9893 19.3707 15.9692 19.4282 15.9376C19.4858 15.9059 19.5365 15.8633 19.5775 15.812L19.89 15.4217C19.9311 15.3704 19.9618 15.3116 19.9801 15.2484C19.9985 15.1853 20.0042 15.1192 19.997 15.0539C19.9897 14.9885 19.9697 14.9253 19.938 14.8677C19.9063 14.8101 19.8635 14.7593 19.8122 14.7183ZM9.27471 4.57705L13.4868 7.87007C13.4174 5.997 11.8899 4.49986 10 4.49986C9.75621 4.50032 9.51313 4.52619 9.27471 4.57705ZM10.7253 11.4228L6.51323 8.12975C6.58292 10.0025 8.11037 11.4996 10 11.4996C10.2438 11.4991 10.4868 11.4734 10.7253 11.4228ZM10 3.49989C13.0827 3.49989 15.9089 5.21859 17.4351 7.99976C17.061 8.68423 16.5987 9.31668 16.0601 9.88095L17.2395 10.8028C17.8961 10.1004 18.4524 9.31052 18.8925 8.45568C18.964 8.31427 19.0013 8.15805 19.0013 7.9996C19.0013 7.84115 18.964 7.68492 18.8925 7.54352C17.1963 4.23706 13.8414 1.99994 10 1.99994C8.85316 1.99994 7.75913 2.21868 6.73041 2.58773L8.18068 3.72176C8.77254 3.58739 9.37877 3.49989 10 3.49989ZM10 12.4996C6.91728 12.4996 4.09143 10.7809 2.56491 7.99976C2.93952 7.31529 3.40231 6.68294 3.94144 6.11888L2.7621 5.19703C2.1056 5.89934 1.54941 6.6891 1.10933 7.54383C1.03785 7.68524 1.0006 7.84147 1.0006 7.99991C1.0006 8.15836 1.03785 8.31459 1.10933 8.45599C2.80397 11.7625 6.15887 13.9996 10 13.9996C11.1468 13.9996 12.2409 13.7793 13.2696 13.4118L11.8193 12.2781C11.2275 12.4121 10.6215 12.4996 10 12.4996Z" fill="#2B4D75"/>
                    </svg>
                </div>
                <button id="goToPass" class="btn btn--success btn--lg sign-in__card--body__login-button w-100" v-if="!loading">{{$t('login.sign_in')}}</button>
                <button class="btn btn--success btn--lg sign-in__card--body__login-button w-100 disabled" v-if="loading">
                    <s-loader :isWhite="true"></s-loader>
                </button>
                <div class="display-table my-3 sign-in__card--body__login-scalify w-100" v-if="isScalifyLogin">
                    <div class="display-table-cell w-100 text-left">
                        <p class="sign-in__card--body__login-scalify--forgot m-0" @click.stop="isScalifyLogin = !isScalifyLogin">{{$t('login.sign_in_differently')}}</p>
                    </div>
                    <div class="display-table-cell w-100 text-right">
                        <p class="sign-in__card--body__login-scalify--forgot m-0" @click.stop="forgot">{{$t('login.forgot')}}</p>
                    </div>
                </div>

                <div class="sign-in__card--body__alert text-capitalize" :class="isScalifyLogin?'':'mt-2'" v-if="messageErreur.length">{{messageErreur.replace(/_/g," ")}}</div>
            </form>
            <!-- login with shopify form -->
            <form v-if="isShopifyLogin && !isBigCommerceLogin " @submit.prevent="loginShopify" class="sign-in__card--body">
                <div class="sign-in__card--body__input-group mb-2">
                    <s-input v-model="storeName" type="text" fieldFor="settings" class="sign-in__card--body__input-group--field" placeholder="Website Name" />
                    <div class="sign-in__card--body__input-group--label display-table">
                        <span class="display-table-cell py-0">.myshopify.com</span>
                    </div>
                </div>
                <button class="btn btn--success btn--lg sign-in__card--body__login-button w-100" v-if="!loading">{{$t('login.sign_in')}}</button>
                <button class="btn btn--success btn--lg sign-in__card--body__login-button w-100 disabled" v-if="loading">
                    <s-loader :isWhite="true"></s-loader>
                </button>
                <div class="display-table my-3 sign-in__card--body__login-scalify w-100 text-center">
                    <p class="sign-in__card--body__login-scalify--forgot m-0 w-100" @click.stop="isShopifyLogin = !isShopifyLogin">{{$t('login.choose_another_sign_in_method')}}</p>
                </div>

                <div class="sign-in__card--body__alert" v-if="messageErreur.length">{{messageErreur}}</div>
            </form>

            <!-- login with bigcommerce form -->
            <form v-if="isBigCommerceLogin && !isShopifyLogin && false " @submit.prevent="loginBigcommerce" class="sign-in__card--body">
                <div class="sign-in__card--body__input-group mb-2">
                    <s-input v-model="storeName" type="text" fieldFor="settings" class="sign-in__card--body__input-group--field" placeholder="Store Name" />
                    <div class="sign-in__card--body__input-group--label display-table">
                        <span class="display-table-cell py-0">.mybigcommerce.com</span>
                    </div>
                </div>
                <button class="btn btn--success btn--lg sign-in__card--body__login-button w-100" v-if="!loading">{{$t('login.sign_in')}}</button>
                <button class="btn btn--success btn--lg sign-in__card--body__login-button w-100 disabled" v-if="loading">
                    <s-loader :isWhite="true"></s-loader>
                </button>
                <div class="display-table my-3 sign-in__card--body__login-scalify w-100 text-center">
                    <p class="sign-in__card--body__login-scalify--forgot m-0 w-100" @click.stop="isBigCommerceLogin = !isBigCommerceLogin">{{$t('login.choose_another_sign_in_method')}}</p>
                </div>

                <div class="sign-in__card--body__alert" v-if="messageErreur.length">{{messageErreur}}</div>
            </form>
        </div>

        <!-- card footer if user haven't account -->
        <!-- <div class="sign-in__second-card">
            <p class="m-0 display-block">{{$t('sign_in.dont_have_account')}}? <span @click.stop="signUp">{{$t('sign_in.sign_up_here')}}</span></p>
        </div> -->
    </div>
</template>

<script>
import Vue from 'vue';
export default {
  name: 'sign-in',
  props:{

  },
  components: {
  },
  watch:{
  },
  data(){
    return{
        loading:false,
        messageErreur:'',
        email: '',
        password: '',
        loadingSignIn:null,
        isScalifyLogin:false,
        typeInputPass:'password',
        isShopifyLogin:false,
        isBigCommerceLogin:false,
        storeName:"",
        isLogged:false,
        test:null
    };
  },

  async mounted(){

    await this.loadGapi()
    // eslint-disable-next-line no-undef
    Vue.prototype.$gapi = gapi ? gapi : null;
    this.$gapi.load('auth2', () => {
        let auth2 = this.$gapi.auth2.init({client_id: "327952325257-caoeijrushnvfct66vnvvgr9vietm4dt.apps.googleusercontent.com",scope: 'email'})
        auth2.attachClickHandler('my-signin2', {}, this.onSignIn, this.onFailure);
    });

    this.$gapi.signin2.render('my-signin2', {
        'longtitle': false
    });

    if (this.$route && this.$route.params && this.$route.params.message) {
      this.messageErreur = this.$route.params.message
    }

    if(this.$route && this.$route.query && this.$route.query.e){
        this.notify("error",this.$route.params.e)
    }

  },

  methods:{
    async loginBigcommerce(){
        try{
            this.loading = true
            let domain = this.storeName.split('.mybigcommerce.com')[0]
            const resultLogin = await this.signUpSignInWithShopify(domain,"sign_in");
            if (resultLogin.data && resultLogin.data.signUpSignInWithShopify) {
                window.open(resultLogin.data.signUpSignInWithShopify,'_self')
            }else{
                if(typeof resultLogin.errors[0] == "string" ){
                    let msg = JSON.parse(resultLogin.errors[0])
                    this.messageErreur = msg.message;
                }
                else{
                    this.messageErreur = resultLogin.errors[0].message;
                }
            }
            this.loading=false;
        }
        catch(err){
            this.loading = false
            this.handleErrors(err)
        }
    },
    async loginShopify(){
        try{
            this.loading = true
            let domain = this.storeName.split('.myshopify.com')[0]
            const resultLogin = await this.signUpSignInWithShopify(domain,"sign_in");
            if (resultLogin.data && resultLogin.data.signUpSignInWithShopify) {
                window.open(resultLogin.data.signUpSignInWithShopify,'_self')
            }else{
                // this.messageErreur = resultLogin.errors[0].message;
                if(typeof resultLogin.errors[0] == "string" ){
                    let msg = JSON.parse(resultLogin.errors[0])
                    this.messageErreur = msg.message;
                }
                else{
                    this.messageErreur = resultLogin.errors[0].message;
                }
            }
            this.loading=false;
        }
        catch(err){
            this.loading = false
            this.handleErrors(err)
        }
    },
    changeInputPassType(){
        if(this.typeInputPass=='password'){
            this.typeInputPass = "text"
        }
        else{
            this.typeInputPass = 'password'
        }
    },
    signinGoogle(){
        this.$refs.googlebtn.click();
    },
    onFailure(data){
        if (data && data.error == "popup_closed_by_user") {
            this.$emit('enable-cookies', true);
        }
    },
    async onSignIn(user) {
        var profile = user.getBasicProfile();
        let token = user.getAuthResponse().id_token
        let g_user = {
            name:profile.getName(),
            email:profile.getEmail(),
            token:token
        }
        this.loadingSignIn = "google"
        const login = await this.loginWithSocialNetwork(g_user,"google")
        console.log('login: ', login);
        if(login.data.loginWithSocialNetwork){
            this.setToken(login.data.loginWithSocialNetwork.access_token);
            const arr = await this.userData();
            console.log('arrarrarr: ', arr);
            if(arr && arr.approved){
                this.$router.push('/');
                this.notify('success', this.$t('success.welcome_back'));
            }else{
                this.$router.push('/complete-subscribe');
            }
        }
        else{
            this.loadingSignIn = null
            // this.messageErreur = login.errors[0].message;
            if(typeof login.errors[0] == "string" ){
                let msg = JSON.parse(login.errors[0])
                this.messageErreur = msg.message;
            }
            else{
                this.messageErreur = login.errors[0].message;
            }
        }
    },
    // access to account
    async loginScalify(){
        this.loading=true;
        console.log('this.isScalifyLogin: ', this.isScalifyLogin);
        if(this.isScalifyLogin){
            try{
                if(this.validationSchema.validate({email: this.email}).error && this.validationSchema.validate({email: this.email}).error.details[0].context.key == "email"){
                    this.messageErreur = this.$t('error.invalid_email_format');
                    this.loading=false;
                }
                else if(this.password.length<9){
                    this.messageErreur = this.$t('error.password_9_charactere')
                    this.loading=false;
                }
                else{
                    const resultLogin = await this.login(this.email,this.password);
                    console.log('resultLogin: ', resultLogin);
                    if (resultLogin.data && resultLogin.data.login) {
                        this.setToken(resultLogin.data.login.access_token);
                        const arr = await this.userData();
                        console.log('arr: ', arr);
                        if(arr){
                            if(Vue.prototype.$isTesting){
                                this.isLogged = true
                            }
                            else if(arr.approved){
                                this.$router.push('/');
                                this.notify('success', this.$t('success.welcome_back'));
                            }else{
                                this.$router.push('/complete-subscribe');
                            }
                            return true
                        }
                        this.loading=false;
                    }else{
                        // this.messageErreur = resultLogin.errors[0].message;
                        if(resultLogin.errors && typeof resultLogin.errors[0] == "string" ){
                            let msg = JSON.parse(resultLogin.errors[0])
                            this.messageErreur = msg.message;
                        }
                        else if(resultLogin.errors){
                            this.messageErreur = resultLogin.errors[0].message;
                        }
                        else{
                            this.messageErreur = this.$t('error.something_wrong')
                        }
                        this.loading=false;
                        return true
                    }
                    this.loading=false;
                }
            }
            catch(err){
                this.loading = false
                this.handleErrors(err)
            }
        }
        else{
            if(this.validationSchema.validate({email: this.email}).error && this.validationSchema.validate({email: this.email}).error.details[0].context.key == "email"){
                this.messageErreur = this.$t('error.invalid_email_format');
                this.loading=false;
            }
            else{
                this.isScalifyLogin = true
                this.loading=false
            }

        }

    },

    async loginUsingFb(){
        const res = await this.facebookLoginSignUp();
        if(res){
            this.loadingSignIn = "facebook"
            const login = await this.loginWithSocialNetwork(res,"facebook")
            if(login.data.loginWithSocialNetwork){
                this.setToken(login.data.loginWithSocialNetwork.access_token);
                const arr = await this.userData();
                if(arr && arr.approved){
                    this.$router.push('/');
                    this.notify('success', this.$t('success.welcome_back'));
                }else{
                    this.$router.push('/complete-subscribe');
                }
            }
            else{
                this.loadingSignIn = null
                if(typeof login.errors[0] == "string" ){
                    let msg = JSON.parse(login.errors[0])
                    this.messageErreur = msg.message;
                }
                else{
                    this.messageErreur = login.errors[0].message;
                }
            }
        }
    },
    // emit that user clicks signup
    signUp(){
        this.$router.push("register")
    },

    //emit that user clicks forgot password
    forgot(){
        this.$router.push({name: 'forgot-password',params:{email:this.email}})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
